import usePageTitle from '../Hooks/usePageTitle';
import { useEffect } from 'react';
import { useAppSelector } from '../Infrastructure/store';
import ApplicationError from '../Infrastructure/Components/ErrorHandling/ApplicationError';
import { ApplicationErrorType } from '../Infrastructure/Components/ErrorHandling/types';
import { useFetchDispatchLegsQuery } from '@api/Trinium/Endpoints/Dispatch/slice';
import DispatchDataGrid from '@components/DataGrid/Dispatch/Grid';
import DispatchSkeleton from './DispatchSkeleton';

import styles from './DispatchGrid.module.css';
import { useMediaQuery, useTheme } from '@mui/material';
import MobileGrid from '@components/DataGrid/Dispatch/MobileGrid';

/**
 * Routed component for /{terminal}/Board
 */
export default function Page() {
  const terminalNumber = useAppSelector((state) => state.applicationState.selectedTerminal?.number as string);
  const { addPageTitle } = usePageTitle();
  const { isLoading, isFetching, currentData, isError, refetch } = useFetchDispatchLegsQuery(terminalNumber);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    addPageTitle('Board');
  }, [addPageTitle]);

  //If we do not have data the endpoint has not been called yet. Or it is in a loading/fetching state.
  if (isLoading || (isFetching && !currentData)) {
    return <DispatchSkeleton />;
  }

  if (isError) {
    return (
      <ApplicationError
        type={ApplicationErrorType.DispatchBoardError}
        messageParam={terminalNumber}
        customAction={{
          buttonText: 'Retry',
          action: () => {
            // If the refetch errors, isError will be true again
            void refetch();
          }
        }}
      />
    );
  }

  if (isMobile) {
    return <MobileGrid />;
  }

  return (
    <div
      className={styles.container}
      key={`${terminalNumber}-dispatch-board`}>
      <DispatchDataGrid />
    </div>
  );
}
